<i18n>
{
	"en": {
		"label": "Order Search Preview",
		"customer": "Customer",
		"fromDespatchParty": "Despatch Party",
		"goodsTypes": "Goods Type",
		"orderTypes": "Order Type",
		"toDeliveryParty": "Delivery Party",
		"pickupStatus": "Pickup Status",
		"deliveryStatus": "Delivery Status",
		"economicalStatus": "Economical Status",
		"orderStatus": "Operational Status",
		"references": "References",
		"searchAreas": "Address / Area",
		"allLocations": "All locations",
		"allCustomers": "All customers",
		"allGoodsTypes": "All goods types",
		"allOrderTypes": "All order types",
		"allStatuses": "All statuses",
		"allEconomicalStatuses": "All economical statuses",
		"allReferences": "All references",
		"cancelled": "Cancelled",
		"draft": "Draft",
		"received": "Received",
		"rejected": "Rejected",
		"ready": "Ready",
		"planned": "Planned",
		"unsuccessful": "Unsuccessful",
		"requested": "Requested",
		"accepted": "Accepted",
		"selectStatus": "Select status",
		"readyForPickup": "Ready for pickup",
		"loaded": "Loaded",
		"unloaded": "Unloaded",
		"incomplete": "Incomplete",
		"notSettled": "Not settled",
		"settled": "Settled",
		"invoiced": "Invoiced",
		"recorded": "Recorded",
		"showAny": "Show Any",
		"notDelivered": "Not Delivered",
		"notPickedUp": "Not Picked Up",
		"onlyDelivered": "Only Delivered",
		"onlyPickedUp": "Only Picked Up",
		"waybillNumber": "Waybill Number",
		"allWaybillNumbers": "All waybill numbers",
		"text": "Text",
		"inboundEdi": "Inbound EDI",
		"mustHaveInboundEdi": "Must have inbound EDI",
		"deviation": "Deviation",
		"deviationFilterLabel": "Deviation"
	},
	"no": {
		"label": "Oppdragssøk forhåndsvisning",
		"customer": "Kunde",
		"fromDespatchParty": "Henteaddresse",
		"goodsTypes": "Godstype",
		"orderTypes": "Oppdragstype",
		"toDeliveryParty": "Leveringsaddresse",
		"pickupStatus": "Hentestatus",
		"deliveryStatus": "Leveringsstatus",
		"economicalStatus": "Økonomisk status",
		"orderStatus": "Operativ status",
		"references": "Referanser",
		"searchAreas": "Adresse / Område",
		"allLocations": "Alle steder",
		"allCustomers": "Alle kunder",
		"allGoodsTypes": "Alle godstyper",
		"allOrderTypes": "Alle oppdragstyper",
		"allStatuses": "Alle statuser",
		"allEconomicalStatuses": "Alle økonomisk statuser",
		"allReferences": "Alle referanser",
		"cancelled": "Annullert",
		"draft": "Kladd",
		"received": "Mottatt",
		"rejected": "Avslått",
		"ready": "Klar",
		"planned": "Planlagt",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Akseptert",
		"selectStatus": "Velg status",
		"readyForPickup": "Klar for henting",
		"loaded": "Lastet",
		"unloaded": "Losset",
		"incomplete": "Ufullstendig",
		"notSettled": "Ikke klarert",
		"settled": "Klarert",
		"invoiced": "Oppgjort",
		"recorded": "Bokført",
		"showAny": "Vis alle",
		"notDelivered": "Ikke levert",
		"notPickedUp": "Ikke hentet",
		"onlyDelivered": "Bare levert",
		"onlyPickedUp": "Bare hentet",
		"waybillNumber": "Fraktbrevnr",
		"allWaybillNumbers": "Alle fraktbrevnr",
		"text": "Tekst",
		"inboundEdi": "Inngående EDI",
		"mustHaveInboundEdi": "Må ha inngående EDI",
		"deviation": "Avvik",
		"deviationFilterLabel": "Avvik"
	}
}
</i18n>
<template>
	<t-vertical-panel class="filters">
		<div class="label">{{$t('label')}}</div>
		<t-form-group
			:title="$t('fromDespatchParty')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="orderCriteria.fromDespatchParty && hasItems(orderFilter.fromDespatchParty)"
				:items="orderFilter.fromDespatchParty"
				notRemovable
				displayKey="label"
			>
				<template v-slot="{ item }">
					<t-location-tag-inner :item="item" displayKey="label" />
				</template>
			</t-tag-container>
			<div v-else class="all">
				{{ $t('allLocations') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('toDeliveryParty')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="orderCriteria.toDeliveryParty && hasItems(orderFilter.toDeliveryParty)"
				:items="orderFilter.toDeliveryParty"
				notRemovable
				displayKey="label"
			>
				<template v-slot="{ item }">
					<t-location-tag-inner :item="item" displayKey="label" />
				</template>
			</t-tag-container>
			<div v-else class="all">
				{{ $t('allLocations') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('customer')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="orderCriteria.customer && hasItems(orderFilter.customer)"
				:items="orderFilter.customer"
				notRemovable
				displayKey="name"
			/>
			<div v-else class="all">
				{{ $t('allCustomers') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('goodsTypes')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="orderCriteria.goodsTypes && hasItems(orderFilter.goodsTypes)"
				:items="orderFilter.goodsTypes"
				notRemovable
				displayKey="name"
			/>
			<div v-else class="all">
				{{ $t('allGoodsTypes') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('orderTypes')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="orderCriteria.orderTypes && hasItems(orderFilter.orderTypes)"
				:items="orderFilter.orderTypes"
				notRemovable
				displayKey="name"
			/>
			<div v-else class="all">
				{{ $t('allOrderTypes') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('orderStatus')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="orderCriteria.orderStatus && hasItems(orderFilter.orderStatus)"
				:items="orderFilter.orderStatus"
				notRemovable
				displayKey="label"
			>
				<template v-slot="{item}">
					<div style="display: flex; align-items: center; justify-content: flex-start;">
						<t-status-color-dot :color="getStatusColor(item)"/>
						<div style="margin-left: 5px;">{{getStatusText(item)}}</div>
					</div>
				</template>
			</t-tag-container>
			<div v-else class="all">
				{{ $t('allStatuses') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('pickupStatus')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag
				v-if="orderCriteria.hasAtd"
				:value="$t(orderFilter.hasAtd.label)"
				notRemovable
			/>
			<div v-else class="all">
				{{ $t('showAny') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('deliveryStatus')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag
				v-if="orderCriteria.hasAta"
				:value="$t(orderFilter.hasAta.label)"
				notRemovable
			/>
			<div v-else class="all">
				{{ $t('showAny') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('economicalStatus')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="orderCriteria.economicalStatus && hasItems(orderFilter.economicalStatus)"
				:items="orderFilter.economicalStatus"
				notRemovable
				displayKey="label"
			>
				<template v-slot="{item}">
					<div style="display: flex; align-items: center; justify-content: flex-start;">
						<t-status-color-dot :color="getStatusColor(item)"/>
						<div style="margin-left: 5px;">{{getEconomicalStatus(item)}}</div>
					</div>
				</template>
			</t-tag-container>
			<div v-else class="all">
				{{ $t('allEconomicalStatuses') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('references')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="orderCriteria.references && hasItems(orderFilter.references)"
				:items="orderFilter.references"
				notRemovable
				displayKey="label"
			/>
			<div v-else class="all">
				{{ $t('allReferences') }}
			</div>
			<div>{{ $t('text') }}: {{orderFilter.referencesText}}</div>
		</t-form-group>
		<t-form-group
			:title="$t('waybillNumber')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="orderCriteria.waybillNumber && hasItems(orderFilter.waybillNumber)"
				:items="orderFilter.waybillNumber"
				notRemovable
				displayKey="id"
			/>
			<div v-else class="all">
				{{ $t('allWaybillNumbers') }}
			</div>
		</t-form-group>

		<t-form-group
			:title="$t('inboundEdi')"
			rowGap="5px"
			class="filter-group"
		>

			<t-checkbox
				:value="orderFilter.mustHaveInboundEdi"
				:checked="orderFilter.mustHaveInboundEdi"
				disabled
				:label="$t('mustHaveInboundEdi')"
				style="margin-bottom: 0; margin-top: 0;"
			/>

			<div
				v-if="orderCriteria.inboundEdi"
			>
				{{ $t('text') }}: {{ orderFilter.inboundEdi }}
			</div>
		</t-form-group>

		<t-form-group
			:title="$t('deviation')"
			rowGap="5px"
			class="filter-group"
		>
			<t-checkbox
				:value="orderFilter.mustHaveDeviation"
				:checked="orderFilter.mustHaveDeviation"
				disabled
				:label="$t('deviationFilterLabel')"
				style="margin-bottom: 0; margin-top: 0;"
			/>

		</t-form-group>

	</t-vertical-panel>
</template>

<script>
import { statuses } from '@/core';

export default {
	name: 'OrderFilters',
	props: {
		orderCriteria: Object,
		orderFilter: Object,
	},
	methods: {
		hasItems(array) {
			return array && array.length > 0;
		},
		getStatusText(status) {
			return this.$t(statuses.operational(status));
		},
		getStatusColor(status) {
			return statuses.color(status);
		},
		getEconomicalStatus(value) {
			return this.$t(statuses.economical(value));
		},
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
.label {
	user-select: none;
	font-size: 14px;
	font-weight: 600;
	line-height: 1.45;
	letter-spacing: 0.3px;
	color: get-color($text, 'dark');
	text-transform: uppercase;
	margin-bottom: 8px;
	margin-left: 1px;
}
.filter-group {
	padding-bottom: 10px;
}
</style>